<div class="ui-g-12 ui-md-6">
  <h2>{{ 'balance.giftReservation' | translate }}</h2>
</div>
<div class="ui-g-12 ui-md-6" style="text-align: right;">
  <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left" (click)="goBack()" label="{{ 'common.back' | translate }}"></button>
</div>
<div class="ui-g-12">
  <form>
    <div class="ui-g-12">
      <div class="ui-g-12 ui-md-4">
        <span class="label">{{ 'balance.customer' | translate }}</span>
        <input style="width: 100%;" name="customer" type="text" pInputText class="fieldInput" [(ngModel)]="customer" disabled/>
      </div>
      <div class="ui-g-12 ui-md-4">
        <span class="label">{{ 'balance.cardNo' | translate }}</span>
        <input style="width: 100%;" name="cardNo" type="text" pInputText class="fieldInput" [(ngModel)]="cardNumber" disabled/>
      </div>
    </div>
    <div class="ui-g-12" *ngIf="accumulator">
      <div class="ui-g-12 ui-md-4">
        <span class="label">{{ 'balance.acm' | translate }}</span>
        <input style="width: 100%;" name="acm" type="text" pInputText class="fieldInput" [(ngModel)]="accumulator" disabled/>
      </div>
      <div *ngIf="this.giftService.search == false"class="ui-g-12 ui-md-4">
        <span class="label">{{ 'reservations.pointsBalance' | translate }}</span>
        <input style="width: 100%;" name="points" type="text" pInputText class="fieldInput" [(ngModel)]="pointsBalance" disabled/>
      </div>
    </div>
  </form>
</div>
<div class="ui-g-12">

  <!-- Table Prenotazioni Attive -->
  <app-loyalty-active-reservations
    *ngIf="reservationState === 'active'"
    [reservations]="reservations"
    [customerId]="customerId"
    [cardNumber]="cardNumber"
    [prefixQrCode]="prefixQrCode"
    (onShowDetails)="showDetails($event)"
    (onGetReservations)="getReservationsList()"
    (onClosePopup)="closePopUp()"
    (onCredit)="creditPoints($event)">
  </app-loyalty-active-reservations>

  <!-- Table Prenotazioni Chiuse -->
  <app-loyalty-closed-reservations
    *ngIf="reservationState === 'closed'"
    [reservations]="reservations"
    (onShowDetails)="showDetails($event)">
  </app-loyalty-closed-reservations>

  <p-dialog
    *ngIf="popUp"
    [(visible)]="popUp"
    [modal]="true"
    header="{{'loyalty.printType' | translate}}"
    [minWidth]="600"
    [draggable]="false"
    [resizable]="false"
    (onHide)="closePopUp()">
    <span>{{ 'loyalty.descriptionPopUpPrint' | translate}}</span><br><br><br>

    <!-- Stampa modulo con tabella degli item -->
    <button pButton class="k-generic-btn" type="button" (click)="generateReportComplete(row.num_reservation)" label="{{ 'loyalty.printModuleCompleteReservation' | translate }}"></button>

    <!-- Stampa modulo singolo item -->
    <button pButton class="k-generic-btn button-item" type="button" (click)="generateReportSpecific(row); closePopUp();" label="{{ 'loyalty.printModuleItem' | translate }}"></button>
  </p-dialog>

  <!-- Pop-up di Dettaglio di un record-->
  <p-dialog
    class="reservation-details-dialog"
    *ngIf="showDetailsDialog"
    [(visible)]="showDetailsDialog"
    [positionTop]="40"
    [positionLeft]="'50%'"
    [modal]="true"
    header="{{modalTitle + ' ' + tempId}}"
    [width]="500"
    [draggable]="false"
    [resizable]="false"
    (onHide)="showDetailsDialog = false">
    <app-loyalty-reservation-details [record]="record"></app-loyalty-reservation-details>
  </p-dialog>


</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-reservations/loyalty-reservations.component.html